export default __webpack_public_path__ + "static/media/token.be91ff78.png";